import { Colors } from '../../../utils/theme';

export const proceBadgeStyles = () => ({
	root: {
		background: Colors['FFF521'],
		borderRadius: '20px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		p: '4px 12px',
		minHeight: '24px',
	},
	priceText: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontSize: '14px',
		lineHeight: '16px',
		mt: '-5px',
	},
	priceIcon: {
		width: { xs: '12px', md: '14px' },
		height: { xs: '18px', md: '20px' },
	},
});
